import { HttpErrorResponse } from '@angular/common/http';

import { PrismicData } from '@dav-model/api/response/prismic-response.model';
import { Action } from '@ngrx/store';

export const LOAD_PRISMIC_DATA = '[PRISMIC] LOAD PRISMIC DATA';
export const LOAD_PRISMIC_DATA_SUCCESS = '[PRISMIC] LOAD PRISMIC DATA SUCCESS';
export const LOAD_PRISMIC_DATA_FAILURE = '[PRISMIC] LOAD PRISMIC DATA FAILURE';

export class LoadPrismicData implements Action {
  readonly type = LOAD_PRISMIC_DATA;
}

export class LoadPrismicDataSuccess implements Action {
  readonly type = LOAD_PRISMIC_DATA_SUCCESS;

  constructor(public payload: { data: PrismicData }) {
  }
}

export class LoadPrismicDataFailure implements Action {
  readonly type = LOAD_PRISMIC_DATA_FAILURE;

  constructor(public payload: { error: HttpErrorResponse }) {
  }
}

export type All = LoadPrismicData | LoadPrismicDataSuccess | LoadPrismicDataFailure;
